module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "fromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "fromDate"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "toDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "toDate"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Search",
      "icon": "pi pi-search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchSalesTaxRegister.apply(null, arguments)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-col-12"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportCSV()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "float": "right",
      "height": "3em",
      "width": "3em"
    },
    attrs: {
      "src": require("../../../../static/img/excel.png")
    }
  })]), _vm._v(" "), _c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.salesInvoiceLists,
      "paginator": true,
      "rowsPerPageOptions": [100, 500, 1000],
      "rows": 100,
      "filters": _vm.filters,
      "data-key": "id",
      "selection": _vm.selectedProduct1,
      "selectionMode": "single"
    },
    on: {
      "update:selection": function($event) {
        _vm.selectedProduct1 = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }])
  }, [_c('Column', {
    attrs: {
      "header": "S.N"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(sl) {
        return [_vm._v("\n                " + _vm._s(sl.index + 1) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Miti",
      "headerStyle": "width:8em;",
      "sortable": true,
      "field": "purchaseSalesDateNepali",
      "filterField": "purchaseSalesDateNepali",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['purchaseSalesDateNepali']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'purchaseSalesDateNepali', $$v)
            },
            expression: "filters['purchaseSalesDateNepali']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Date",
      "headerStyle": "width:8em;",
      "sortable": true,
      "field": "purchaseSalesDate",
      "filterField": "purchaseSalesDate",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['purchaseSalesDate']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'purchaseSalesDate', $$v)
            },
            expression: "filters['purchaseSalesDate']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Bill No",
      "sortable": true,
      "field": "billNo",
      "filterField": "billNo",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['billNo']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'billNo', $$v)
            },
            expression: "filters['billNo']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Customer",
      "sortable": true,
      "field": "accountName",
      "filterField": "accountName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['accountName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'accountName', $$v)
            },
            expression: "filters['accountName']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                Total:\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Address",
      "sortable": true,
      "field": "address",
      "filterField": "address",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['address']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'address', $$v)
            },
            expression: "filters['address']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Sub Total",
      "bodyStyle": "text-align: right",
      "field": "subTotalAmount",
      "filterField": "subTotalAmount",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['subTotalAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'subTotalAmount', $$v)
            },
            expression: "filters['subTotalAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalSubAmount.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Non-taxable",
      "bodyStyle": "text-align: right",
      "field": "nonTaxableAmount",
      "filterField": "nonTaxableAmount",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['nonTaxableAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'nonTaxableAmount', $$v)
            },
            expression: "filters['nonTaxableAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalNonTaxableAmount.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Taxable",
      "bodyStyle": "text-align: right",
      "field": "taxableAmount",
      "filterField": "taxableAmount",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['taxableAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'taxableAmount', $$v)
            },
            expression: "filters['taxableAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalTaxableAmount.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Vat",
      "bodyStyle": "text-align: right",
      "field": "vatAmount",
      "filterField": "vatAmount",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['vatAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'vatAmount', $$v)
            },
            expression: "filters['vatAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalVatAmount.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Total",
      "bodyStyle": "text-align: right",
      "field": "totalBillAmount",
      "filterField": "totalBillAmount",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['totalBillAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'totalBillAmount', $$v)
            },
            expression: "filters['totalBillAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalSumBillAmount.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Org Name",
      "sortable": true,
      "field": "organisationName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['organisationName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'organisationName', $$v)
            },
            expression: "filters['organisationName']"
          }
        })]
      },
      proxy: true
    }])
  })], 1)], 1)])])]), _vm._v(" "), _c('Dialog', {
    on: {
      "cancel": _vm.cancel,
      "deleted": _vm.deleteReport
    },
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a6cd101"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/salesReport/salesTaxRegister.vue
// module id = 2066
// module chunks = 0